module.exports = __webpack_public_path__ + "static/media/importICS2.58cdaac5.png";